import 'magnific-popup';
require('slick-carousel');

var fiat = fiat || {
    popupLink: function () {

        $('.js-popup-link').magnificPopup({
            type: 'ajax',
            mainClass: 'popup-contents',
            alignTop: true,
            overflowY: 'scroll',
            myClassOne: 'content-popup',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='content-popup'>" + mfpResponse.data + "</div>";
                },
                ajaxContentAdded: function () {
                    return this.content;
                }
            }
        });

        $('.accept-privacy .privacy-notes a').magnificPopup({
            type: 'inline',
            mainClass: 'popup-contents',
            alignTop: true,
            overflowY: 'scroll',
            myClassOne: 'content-popup',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='content-popup'>" + mfpResponse.data + "</div>";
                }
            }
        });

        $('.accept-privacy .form-group a').magnificPopup({
            type: 'inline',
            mainClass: 'popup-contents-mini',
            alignTop: true,
            overflowY: 'scroll',
            myClassOne: 'content-popup',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='content-popup'>" + mfpResponse.data + "</div>";
                }
            }
        });
    },
    init: function (form) {
        this.popupLink();
    }
};

$(document).ready(function () {
    fiat.init();
});
